<div class="wrapper">
  <p-skeleton *ngIf="loading" styleClass="skeleton"></p-skeleton>
  <a
    *ngIf="!loading"
    class="article"
    [routerLink]="article.slug"
    [style.background-image]="articleImageSrc"
    appSpot
    text="Découvrir"
    icon="/icons/seeMore.svg"
    backgroundColor="#D17A2A"
    target="_blank"
    #articleLink
  >
    <div class="article-title">
      <div class="destination" *ngIf="article.place">
        <p class="upper">
          {{ article.place }}, <em>{{ article.destination?.country }}</em>
        </p>
      </div>
      <h2 [innerHTML]="article.name"></h2>
    </div>
  </a>
</div>
